module.exports = __webpack_public_path__ + "static/media/subscription.3ba05dd0.jpg";